import { render } from "./newDay2Content.vue?vue&type=template&id=503b8a0c&scoped=true&ts=true"
import script from "./newDay2Content.vue?vue&type=script&lang=ts"
export * from "./newDay2Content.vue?vue&type=script&lang=ts"

import "./newDay2Content.vue?vue&type=style&index=0&id=503b8a0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503b8a0c"]])

export default __exports__